import Rate1 from '../../assets/images/rate-1.png';
import Rate2 from '../../assets/images/rate-2.png';
import Rate3 from '../../assets/images/rate-3.png';
import Rate4 from '../../assets/images/rate-4.png';
import Rate5 from '../../assets/images/rate-5.png';

import Astronaut from '../../assets/images/feedback-img.png';
import styles from './index.module.scss';
import { useRateStory } from '@coreStory/useCase';
import { useParams } from 'react-router-dom';
import { IRateData } from '@coreStory/type';

const Feedback = () => {
  const { id } = useParams();
  const { mutate } = useRateStory();
  const handleRateStory = (rate: string) => {
    if (id) {
      const data: IRateData = {
        rate,
        storyid: id,
      };
      mutate(data);
    }
  };
  return (
    <div className={styles['feedback_card']}>
      <div className={styles['img_card']}>
        <img src={Astronaut} alt="Astronaut Image" />
      </div>
      <div className={styles['icon_card']}>
        <img
          onClick={() => handleRateStory('5')}
          className={styles['icons']}
          src={Rate5}
          alt="Heart Eyes Emoji"
        />
        <img
          onClick={() => handleRateStory('4')}
          className={styles['icons']}
          src={Rate4}
          alt="Smile Face Emoji"
        />
        <img
          onClick={() => handleRateStory('3')}
          className={styles['icons']}
          src={Rate3}
          alt="Smile Face Emoji"
        />
        <img
          onClick={() => handleRateStory('2')}
          className={styles['icons']}
          src={Rate2}
          alt="Poker Face Emoji"
        />
        <img
          onClick={() => handleRateStory('1')}
          className={styles['icons']}
          src={Rate1}
          alt="Look Down Emoji"
        />
      </div>
    </div>
  );
};

export default Feedback;
